import Chart from "chart.js/auto";

const modal = document.getElementById("modal");
const form = document.getElementById("weight-form");
const dateInput = document.getElementById("date");
const weightInput = document.getElementById("weight");
const formError = document.getElementById("form-error");
const historyEl = document.getElementById("history");
const historyEmpty = document.getElementById("history-empty");
const chartEmpty = document.getElementById("chart-empty");
const statsEl = document.getElementById("stats");
const rangeStatEl = document.getElementById("range-stat");
const statCurrent = document.getElementById("stat-current");
const statChange = document.getElementById("stat-change");
const statLow = document.getElementById("stat-low");

let chart = null;

function todayStr() {
  const d = new Date();
  const off = d.getTimezoneOffset();
  return new Date(d.getTime() - off * 60000).toISOString().slice(0, 10);
}

function fmtDate(iso) {
  const [y, m, d] = iso.split("-").map(Number);
  return new Date(y, m - 1, d).toLocaleDateString(undefined, {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
}

async function fetchWeights() {
  const res = await fetch("/api/weights");
  return res.json();
}

function renderChart(data) {
  const labels = data.map((d) => fmtDate(d.date));
  const values = data.map((d) => d.weight);

  if (chart) chart.destroy();
  const canvas = document.getElementById("chart");

  if (data.length === 0) {
    chartEmpty.classList.remove("hidden");
    canvas.classList.add("hidden");
    return;
  }
  chartEmpty.classList.add("hidden");
  canvas.classList.remove("hidden");

  const ctx = canvas.getContext("2d");
  const fill = ctx.createLinearGradient(0, 0, 0, 260);
  fill.addColorStop(0, "rgba(168, 85, 247, 0.35)");
  fill.addColorStop(0.5, "rgba(236, 72, 153, 0.18)");
  fill.addColorStop(1, "rgba(236, 72, 153, 0)");

  const stroke = ctx.createLinearGradient(0, 0, canvas.width, 0);
  stroke.addColorStop(0, "#fb7185");
  stroke.addColorStop(0.5, "#ec4899");
  stroke.addColorStop(1, "#a855f7");

  chart = new Chart(ctx, {
    type: "line",
    data: {
      labels,
      datasets: [
        {
          data: values,
          borderColor: stroke,
          borderWidth: 3,
          backgroundColor: fill,
          fill: true,
          tension: 0.4,
          pointBackgroundColor: "#fff",
          pointBorderColor: "#db2777",
          pointBorderWidth: 2,
          pointRadius: 5,
          pointHoverRadius: 7,
          pointHoverBorderWidth: 3,
        },
      ],
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      animation: { duration: 700, easing: "easeOutQuart" },
      plugins: {
        legend: { display: false },
        tooltip: {
          backgroundColor: "rgba(74, 44, 61, 0.92)",
          padding: 12,
          cornerRadius: 12,
          titleFont: { family: "Nunito", weight: "700" },
          bodyFont: { family: "Nunito" },
          displayColors: false,
          callbacks: { label: (c) => `${c.parsed.y.toFixed(1)} lbs` },
        },
      },
      scales: {
        y: {
          grid: { color: "rgba(251, 207, 232, 0.5)" },
          border: { display: false },
          ticks: { color: "#a47f90", font: { family: "Nunito", weight: "600" } },
        },
        x: {
          grid: { display: false },
          border: { display: false },
          ticks: {
            color: "#a47f90",
            font: { family: "Nunito", weight: "600" },
            maxRotation: 0,
            autoSkip: true,
            maxTicksLimit: 6,
          },
        },
      },
    },
  });
}

function renderStats(data) {
  if (data.length === 0) {
    statCurrent.textContent = "—";
    statChange.textContent = "—";
    statChange.className = "stat-value";
    statLow.textContent = "—";
    rangeStatEl.textContent = "";
    return;
  }
  const latest = data[data.length - 1].weight;
  const first = data[0].weight;
  const diff = latest - first;
  const low = Math.min(...data.map((d) => d.weight));

  statCurrent.textContent = latest.toFixed(1);

  const sign = diff > 0 ? "+" : diff < 0 ? "−" : "";
  statChange.textContent = `${sign}${Math.abs(diff).toFixed(1)}`;
  statChange.className = "stat-value " + (diff > 0 ? "up" : diff < 0 ? "down" : "");

  statLow.textContent = low.toFixed(1);

  rangeStatEl.textContent = `${fmtDate(data[0].date)} → ${fmtDate(data[data.length - 1].date)}`;
}

function renderHistory(data) {
  historyEl.innerHTML = "";
  if (data.length === 0) {
    historyEmpty.classList.remove("hidden");
    statsEl.textContent = "";
    return;
  }
  historyEmpty.classList.add("hidden");

  statsEl.textContent = `${data.length} ${data.length === 1 ? "entry" : "entries"}`;

  // newest first, with delta vs previous chronological entry
  let row = 0;
  for (let i = data.length - 1; i >= 0; i--) {
    const entry = data[i];
    const prev = i > 0 ? data[i - 1] : null;
    const li = document.createElement("li");
    li.style.animationDelay = `${row++ * 0.04}s`;

    const date = document.createElement("span");
    date.className = "h-date";
    date.textContent = fmtDate(entry.date);

    const right = document.createElement("div");
    right.className = "h-right";

    if (prev) {
      const diff = entry.weight - prev.weight;
      const delta = document.createElement("span");
      delta.className = "h-delta " + (diff > 0 ? "up" : diff < 0 ? "down" : "");
      delta.textContent = (diff > 0 ? "▲ " : diff < 0 ? "▼ " : "") + Math.abs(diff).toFixed(1);
      right.appendChild(delta);
    }

    const weight = document.createElement("span");
    weight.className = "h-weight";
    weight.textContent = entry.weight.toFixed(1);

    const del = document.createElement("button");
    del.className = "delete-btn";
    del.innerHTML = "✕";
    del.title = "Delete entry";
    del.onclick = () => deleteEntry(entry.date);

    right.append(weight, del);
    li.append(date, right);
    historyEl.appendChild(li);
  }
}

async function refresh() {
  const data = await fetchWeights();
  renderStats(data);
  renderChart(data);
  renderHistory(data);
}

async function deleteEntry(date) {
  await fetch(`/api/weights/${date}`, { method: "DELETE" });
  refresh();
}

function openModal() {
  formError.classList.add("hidden");
  dateInput.value = todayStr();
  weightInput.value = "";
  modal.classList.remove("hidden");
  weightInput.focus();
}

function closeModal() {
  modal.classList.add("hidden");
}

document.getElementById("add-btn").onclick = openModal;
document.getElementById("cancel-btn").onclick = closeModal;
modal.onclick = (e) => {
  if (e.target === modal) closeModal();
};
document.addEventListener("keydown", (e) => {
  if (e.key === "Escape" && !modal.classList.contains("hidden")) closeModal();
});

form.onsubmit = async (e) => {
  e.preventDefault();
  formError.classList.add("hidden");

  const res = await fetch("/api/weights", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      date: dateInput.value,
      weight: parseFloat(weightInput.value),
    }),
  });

  if (!res.ok) {
    const err = await res.json();
    formError.textContent = err.error || "Something went wrong";
    formError.classList.remove("hidden");
    return;
  }

  closeModal();
  refresh();
};

refresh();
